import Env from '@lib/Env';
import store from '@/store';

import { AuthorizeMiddleware } from '@lib/@m7/oauth2-client';
import { ApiConnectorInstance } from '@/Singletons';

export default function init() {
    return new Promise((resolve, reject) => {
        try {
            if (AuthorizeMiddleware(Env.services.auth.redirect_uri, { closeWindow: false })) {
                return reject('is_authorization');
            }
        } catch (error) {
            return reject(error);
        }

        let created = (): void => undefined;
        let mounted = (): void => undefined;

        Env.log.debug('Initializing app');

        // Enable if cordova
        // if(Env.hasFeature(Env.features.CORDOVA))
        // 	return CordovaInit();

        const loadDataThenResolve = () => {
            store.dispatch('loadMainData').finally(() => {
                resolve({ created, mounted });
            });
        };

        // Not logged in
        if (!store.getters.getHasAccessToken) {
            return resolve({ created, mounted });
        }

        // Has invalid token with refresh token, do refresh
        if (
            store.getters.getHasAccessToken &&
            !store.getters.getHasValidAccessToken &&
            store.getters.getAccessToken.hasRefreshToken()
        ) {
            return ApiConnectorInstance.refreshAccessToken()
                .then((accessToken) => {
                    store.commit('setAccessToken', accessToken);
                    loadDataThenResolve();
                })
                .catch((err) => {
                    resolve({ created, mounted });
                });
        }

        // Has invalid access token without refresh token
        if (!store.getters.getHasValidAccessToken) {
            return resolve({ created, mounted });
        }

        // Has valid access token
        loadDataThenResolve();
    });
}
